module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// /Users/nathan/dev/piggybk/aws-amplify/node_modules/aws-sdk/apis/sts-2011-06-15.paginators.json
// module id = 356
// module chunks = 0 1